import React from 'react';
import LoadingSpinner from 'app/common/components/Spinner/LoadingSpinner';

const LazySpinner: React.FC = () => (
  <LoadingSpinner visible />
);

export default LazySpinner;
